import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopNav from "./TopNav.jsx";
import Footer from "./Footer.jsx";

// Wraps every page: sticky nav, the routed page, and the footer.
// Also scrolls to top on route change so deep navigation feels natural.
export default function AppShell({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="app-shell">
      <TopNav />
      <main className="app-main">{children}</main>
      <Footer />
    </div>
  );
}
